import { useEffect, useContext } from 'react';
import { storeContext } from '../../provider/Provider';
import usePremiumBacklink from './usePremiumBacklink';

const useLoadPremiumBacklink = () => {
  const { state } = useContext(storeContext);
  const { premiumBacklinks } = state;

  // Get API functions from usePremiumBacklink
  const { fetchPremiumBacklinks, fetchPremiumBacklinkOrders, fetchPremiumBacklinkClientProfiles } = usePremiumBacklink();

  // Load premium backlink client profiles first (required for other API calls)
  useEffect(() => {
    const loadClientProfiles = async () => {
      try {
        await fetchPremiumBacklinkClientProfiles();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log('Error loading premium backlink client profiles:', error);
      }
    };
    
    loadClientProfiles();
  }, [fetchPremiumBacklinkClientProfiles]);

  // Load premium backlinks data (after client profiles are loaded)
  useEffect(() => {
    // Only load backlinks if client profiles are available
    if (premiumBacklinks.clientProfiles && premiumBacklinks.clientProfiles.length > 0) {
      const loadBacklinks = async () => {
        try {
          await fetchPremiumBacklinks();
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log('Error loading premium backlinks:', error);
        }
      }; 

      loadBacklinks();
    }
  }, [fetchPremiumBacklinks, premiumBacklinks.clientProfiles, premiumBacklinks.pagination.currentPage, premiumBacklinks.pagination.perPage, premiumBacklinks.filters]);

  // Load premium backlink orders (after client profiles are loaded)
  useEffect(() => {
    // Only load orders if client profiles are available
    if (premiumBacklinks.clientProfiles && premiumBacklinks.clientProfiles.length > 0) {
      const loadOrders = async () => {
        try {
          await fetchPremiumBacklinkOrders();
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log('Error loading premium backlink orders:', error);
        }
      };
      
      loadOrders();
    }
  }, [fetchPremiumBacklinkOrders, premiumBacklinks.clientProfiles]);



};

export default useLoadPremiumBacklink; 